import { defineComponent as f, computed as p, capitalize as n, createElementBlock as l, createBlock as v, openBlock as i, createElementVNode as s, toDisplayString as a, Fragment as d, renderList as b, createCommentVNode as m, withModifiers as _, normalizeClass as I } from "vue";
import w from "./HeaderListbox.vue.js";
const C = {
  key: 0,
  class: "header-group"
}, B = { class: "header-group-label" }, E = { class: "header-group-items" }, N = {
  key: 0,
  class: "header-group-item"
}, V = ["href", "onClick"], A = {
  key: 1,
  class: "header-group-item"
}, L = ["href"], H = /* @__PURE__ */ f({
  __name: "HeaderItemGroup",
  props: {
    group: {},
    isEditable: { type: Boolean },
    isMobile: { type: Boolean },
    resolveInternalLinks: { type: Function },
    linkIsActive: { type: Function }
  },
  emits: ["navigate"],
  setup(u, { emit: c }) {
    const r = u, h = c, y = p(() => r.group.children.filter((e) => e.show || r.isEditable).filter(
      (e) => e.type === "guide" || e.type === "reference" || e.type === "link"
    ).map((e) => ({
      id: e.uid,
      label: e.title || n(e.type)
    }))), g = p(() => {
      const e = r.group.children.find((o) => r.linkIsActive(o));
      return e ? { id: e.uid, label: e.title || n(e.type) } : { id: "null", label: "null" };
    }), k = ({ id: e }) => {
      const o = r.group.children.find((t) => t.uid === e);
      (o?.type === "reference" || o?.type === "guide") && h("navigate", o.uid, o.type), o?.type === "link" && window.open(o.link, "_blank", "noopener noreferrer");
    };
    return (e, o) => e.isMobile ? (i(), l("div", C, [
      s("div", B, a(e.group.title || n(e.group.type)), 1),
      s("ul", E, [
        (i(!0), l(d, null, b(e.group.children, (t) => (i(), l(d, {
          key: t.uid
        }, [
          (t.type === "guide" || t.type === "reference") && (t.show || e.isEditable) ? (i(), l("li", N, [
            s("a", {
              class: I(["header-item-link", {
                "header-item-active": e.linkIsActive(t),
                "header-item-ghost": !t.show
              }]),
              href: e.resolveInternalLinks(t),
              onClick: _((F) => e.$emit("navigate", t.uid, t.type), ["prevent"])
            }, a(t.title || n(t.type)), 11, V)
          ])) : t.type === "link" && t.show ? (i(), l("li", A, [
            s("a", {
              class: "header-item-link",
              href: t.link || "#",
              rel: "noopener noreferrer",
              target: "_blank"
            }, a(t.title || n(t.type)), 9, L)
          ])) : m("", !0)
        ], 64))), 128))
      ])
    ])) : (i(), v(w, {
      key: 1,
      buttonClass: [e.linkIsActive(e.group) && "header-item-active"],
      buttonName: e.group.title || n(e.group.type),
      modelValue: g.value,
      options: y.value,
      static: "",
      "onUpdate:modelValue": k
    }, null, 8, ["buttonClass", "buttonName", "modelValue", "options"]));
  }
});
export {
  H as default
};
